import { useState } from "react";
import { IconButton } from "@material-ui/core";
import {
  columnTextField,
  columnNumberField,
  columnCNPJCPFField,
} from "utils/tables-utils";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { Visibility } from "@mui/icons-material";
import DialogPedidoDetails from "./dialog-pedido-details";

export default function TablePedidos({ data, totalRegistros, loading, extraActions }) {
  const [selectedPedido, setSelectedPedido] = useState(null);
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);

  const columnModel = [
    columnNumberField({
      dataField: "NumeroPedido",
      text: "Pedido",
    }),
    columnTextField({
      dataField: "NumeroProposta",
      text: "Proposta",
    }),
    columnCNPJCPFField({
      dataField: "Cnpj",
      text: "CNPJ",
    }),
    columnTextField({
      dataField: "RazaoSocial",
      text: "Razão Social",
    }),
    columnTextField({
      dataField: "ParcialmenteFaturado",
      text: "Parcialmente Faturado",
      align: "center",
      formatter: (_, row) => {
        const valorEmAberto = parseFloat(
          row.ValorEmAberto?.replace(/\./g, "").replace(",", ".") || "0"
        );
        return valorEmAberto > 0 ? "Sim" : "Não";
      },
    }),
    columnTextField({
      dataField: "Status",
      text: "Status",
      align: "center",
      formatter: (cell) => {
        return cell || "-";
      },
    }),
    columnTextField({
      dataField: "DataPedido",
      text: "Data Pedido",
      align: "center",
      formatter: (cell) => {
        return cell || "-";
      },
    }),
    columnTextField({
      dataField: "UltimaConfirmacao",
      text: "Última Confirmação",
      align: "center",
      formatter: (cell) => cell || "-",
    }),
    columnTextField({
      dataField: "PrazoEntrega",
      text: "Prazo Entrega",
      align: "center",
      formatter: (cell) => cell || "-",
    }),
    columnTextField({
      dataField: "NomeRepresentante",
      text: "Nome do Representante",
      formatter: (cell) => cell || "-",
    }),
    columnTextField({
      dataField: "ValorFaturado",
      text: "Valor Faturado",
      align: "right",
      formatter: (cell) => {
        return cell ? `R$ ${cell}` : "R$ 0,00";
      },
    }),
    columnTextField({
      dataField: "ValorEmAberto",
      text: "Valor em Aberto",
      align: "right",
      formatter: (cell) => {
        return cell ? `R$ ${cell}` : "R$ 0,00";
      },
    }),
    columnTextField({
      dataField: "Marca",
      text: "Marca",
    }),
    columnTextField({
      dataField: "CondicaoPagamento",
      text: "Condição Pagamento",
      formatter: () => "-",
    }),
    columnTextField({
      dataField: "PrevisaoFaturamento",
      text: "Previsão Faturamento",
      align: "center",
      formatter: () => "-",
    }),
    columnTextField({
      dataField: "Pendencias",
      text: "Pendências",
      formatter: () => "-",
    }),
    columnTextField({
      dataField: "TabelaPreco",
      text: "Tabela de Preço",
      formatter: () => "-",
    }),
    columnTextField({
      dataField: "actions",
      text: "Ações",
      formatter: (_, row) => {
        return (
          <IconButton
            size="small"
            onClick={() => {
              setSelectedPedido(row);
              setDetailsDialogOpen(true);
            }}
          >
            <Visibility fontSize="small" />
          </IconButton>
        );
      },
    }),
  ];

  return (
    <>
      <ToolkitTable
        dataTable={data}
        columnModel={columnModel}
        keyField="NumeroPedido"
        showPrint
        extraActions={extraActions}
        pagination={{
          options: [10, 25, 50, 100],
          defaultOption: 10,
          totalSize: totalRegistros,
          showTotal: true,
        }}
        loading={loading}
        style={{
          boxShadow: "none",
          margin: "0 -1rem",
        }}
      />
      {detailsDialogOpen && (
        <DialogPedidoDetails
          open={true}
          onClose={() => {
            setDetailsDialogOpen(false);
            setSelectedPedido(null);
          }}
          orderId={selectedPedido?.NumeroPedido}
        />
      )}
    </>
  );
}
